import React, { useRef } from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import { ReactComponent as PhotoUploadIcon } from "../../../../../assets/images/People/Customers/photo-upload.svg";
import { colorCodesForAvatar } from "../../../../../constants/index";
import { chracterPosition } from "../../../../../utils/index";

const AVATAR_SIZE = 56;

export default function CustomerEditPhoto({ name, avatarSrc, onFileSelect }) {
  const inputRef = useRef(null);
  const letter = (name || "?").substring(0, 1).toUpperCase();

  return (
    <Box sx={{ mb: 1 }}>
      <Box
        component="button"
        type="button"
        onClick={() => inputRef.current?.click()}
        sx={{
          position: "relative",
          width: AVATAR_SIZE,
          height: AVATAR_SIZE,
          p: 0,
          border: "none",
          background: "transparent",
          cursor: "pointer",
          borderRadius: "50%",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #FFC53D 0%, #FF7A45 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: "3px",
            boxSizing: "border-box",
          }}
        >
          <Avatar
            src={avatarSrc || undefined}
            alt={name}
            sx={{
              width: "100%",
              height: "100%",
              fontSize: 20,
              bgcolor: colorCodesForAvatar[chracterPosition(letter)] || "#405261",
            }}
          >
            {letter}
          </Avatar>
        </Box>
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: avatarSrc ? "rgba(255, 255, 255, 0.55)" : "transparent",
            pointerEvents: "none",
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              bgcolor: "#FFFFFF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PhotoUploadIcon style={{ width: 24, height: 24, display: "block" }} />
          </Box>
        </Box>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          hidden
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) onFileSelect?.(file);
            e.target.value = "";
          }}
        />
      </Box>
    </Box>
  );
}
